// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import "bootstrap";
import BootstrapVue from "bootstrap-vue";

import "flatpickr/dist/themes/material_blue.css";
import "material-design-icons/iconfont/material-icons.css";
import "typeface-roboto/index.css";

import "snackbarjs";

import "select2";
import "select2/dist/css/select2.css";

import { longClickDirective } from "vue-long-click";
const longClickInstance = longClickDirective({ delay: 800 });
Vue.directive("longclick", longClickInstance);

import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();

import App from "./App";
import router from "./router";
import globals from "./globals";
import feature from "./feature";

// Import JS services
import appService from "./services/app.service";
Object.defineProperty(Vue.prototype, "$appService", {
  value: appService,
});

import VueCurrencyInput from "vue-currency-input";
Vue.use(VueCurrencyInput);

Vue.use(BootstrapVue);

Vue.config.productionTip = false;

Vue.prototype.globals = globals;
Vue.prototype.feature = feature;

// Send access token to service worker if requested.
const authChannel = new BroadcastChannel("authChannel");

authChannel.onmessage = (event) => {
  if (event.data === "getAuthTokenHeader") {
    authChannel.postMessage({
      authTokenHeader: `Bearer ${appService.getAccessToken()}`,
    });
  }
};

router.beforeEach((to, from, next) => {
  if (to.name === "DirectToLoginCallback") {
    appService.redirectAfterLoginCallback();
    return;
  }

  if (to.name === "DirectToLogoutCallback") {
    appService.redirectAfterLogoutCallback();
    return;
  }

  if (to.name === "SurveyCodeLogin" || to.name === "SurveyCodeDirectLogin") {
    appService.removeTokensFromStorage();
    appService.directToLogin(true, to.params.sc);
    return;
  }

  if (!appService.isUserAuthenticated()) {
    appService.renewToken();
  }

  if (
    globals.isSurveyCodeUser &&
    (to.name === "Settlement" || to.name === "FreeOffers")
  ) {
    next("/surveyview");
    return;
  }

  next();
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: {
    App,
  },
});



// WEBPACK FOOTER //
// ./src/main.js